module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-card",
    class: {
      'align-middle': !_vm.showDocumentSidebar && !_vm.showModuleSidebar && !_vm.showTemplateSidebar
    }
  }, [_vm._t("document-title"), _vm._v(" "), (_vm.documentLoaded === false) ? _c('loading-indicator') : _vm._e(), _vm._v(" "), (_vm.documentLoaded && _vm.payload.cover) ? _c('document-part-cover', {
    attrs: {
      "payload": _vm.payload,
      "state": "editor"
    },
    on: {
      "update": _vm.updateCover
    }
  }) : _vm._e(), _vm._v(" "), (_vm.documentLoaded) ? _c('div', {
    staticClass: "document",
    class: {
      'is-module': _vm.$route.path.indexOf('/module/') > -1
    },
    style: ({
      'font-family': _vm.payload.options.documentFont
    })
  }, [_c('draggable', {
    attrs: {
      "list": _vm.payload.body,
      "options": {
        group: 'omega',
        handle: '.handle'
      }
    },
    on: {
      "sort": _vm.flattenModules
    }
  }, [_c('transition-group', _vm._l((_vm.payload.body), function(part, key) {
    return _c('div', {
      key: part.id,
      staticClass: "document-item"
    }, [_c('div', {
      staticClass: "columns"
    }, [_c('div', {
      staticClass: "document-drag-zone"
    }, [_vm._v(_vm._s(_vm.$t('proposal_editor_modal.drop_content_here')))]), _vm._v(" "), _c('div', {
      staticClass: "column is-1"
    }, [_c('div', {
      staticClass: "handle"
    }, [_c('span', {
      staticClass: "handle-dot"
    }, [_c('i', {
      staticClass: "icon icon-move"
    })])]), _vm._v(" "), (part.type === 'h1') ? _c('span', {
      staticClass: "document-item-type"
    }, [_c('i', {
      staticClass: "icon icon-h1"
    }), _vm._v(" "), _c('ul', {
      staticClass: "document-item-type-changer"
    }, [_c('li', {
      on: {
        "click": function($event) {
          _vm.convertPart(part, 'h2')
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-h2"
    })]), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          _vm.convertPart(part, 'h3')
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-h3"
    })]), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          _vm.convertPart(part, 'text')
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-p"
    })])])]) : _vm._e(), _vm._v(" "), (part.type === 'h2') ? _c('span', {
      staticClass: "document-item-type"
    }, [_c('i', {
      staticClass: "icon icon-h2"
    }), _vm._v(" "), _c('ul', {
      staticClass: "document-item-type-changer"
    }, [_c('li', {
      on: {
        "click": function($event) {
          _vm.convertPart(part, 'h1')
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-h1"
    })]), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          _vm.convertPart(part, 'h3')
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-h3"
    })]), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          _vm.convertPart(part, 'text')
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-p"
    })])])]) : _vm._e(), _vm._v(" "), (part.type === 'h3') ? _c('span', {
      staticClass: "document-item-type"
    }, [_c('i', {
      staticClass: "icon icon-h3"
    }), _vm._v(" "), _c('ul', {
      staticClass: "document-item-type-changer"
    }, [_c('li', {
      on: {
        "click": function($event) {
          _vm.convertPart(part, 'h1')
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-h1"
    })]), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          _vm.convertPart(part, 'h2')
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-h2"
    })]), _vm._v(" "), _c('li', {
      on: {
        "click": function($event) {
          _vm.convertPart(part, 'text')
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-p"
    })])])]) : _vm._e(), _vm._v(" "), (part.type === 'bulleted-list') ? _c('span', {
      staticClass: "document-item-type"
    }, [_c('i', {
      staticClass: "icon icon-bulleted-list"
    })]) : _vm._e(), _vm._v(" "), (part.type === 'numbered-list') ? _c('span', {
      staticClass: "document-item-type"
    }, [_c('i', {
      staticClass: "icon icon-numbered-list"
    })]) : _vm._e(), _vm._v(" "), (part.type === 'image') ? _c('span', {
      staticClass: "document-item-type"
    }, [_c('i', {
      staticClass: "icon icon-image"
    })]) : _vm._e(), _vm._v(" "), (part.type === 'table') ? _c('span', {
      staticClass: "document-item-type"
    }, [_c('i', {
      staticClass: "icon icon-table"
    })]) : _vm._e(), _vm._v(" "), (part.type === 'pricing-table') ? _c('span', {
      staticClass: "document-item-type"
    }, [_c('i', {
      staticClass: "icon icon-pricing-table"
    })]) : _vm._e(), _vm._v(" "), (part.type === 'signatures') ? _c('span', {
      staticClass: "document-item-type"
    }, [_c('i', {
      staticClass: "icon icon-signature"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "column is-10"
    }, [_c('div', {
      staticClass: "part-wrapper"
    }, [(part.type === 'h1') ? _c('document-part-h1', {
      attrs: {
        "part": part,
        "state": "editor"
      },
      on: {
        "update": _vm.updateContent
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'h2') ? _c('document-part-h2', {
      attrs: {
        "part": part,
        "state": "editor"
      },
      on: {
        "update": _vm.updateContent
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'h3') ? _c('document-part-h3', {
      attrs: {
        "part": part,
        "state": "editor"
      },
      on: {
        "update": _vm.updateContent
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'text') ? _c('document-part-text', {
      attrs: {
        "part": part,
        "state": "editor"
      },
      on: {
        "update": _vm.updateContent
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'bulleted-list') ? _c('document-part-bulleted-list', {
      attrs: {
        "part": part,
        "state": "editor"
      },
      on: {
        "update": _vm.updateContent
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'numbered-list') ? _c('document-part-numbered-list', {
      attrs: {
        "part": part,
        "state": "editor"
      },
      on: {
        "update": _vm.updateContent
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'image') ? _c('document-part-image', {
      attrs: {
        "part": part,
        "state": "editor"
      },
      on: {
        "update": _vm.updateContent
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'table') ? _c('document-part-table', {
      attrs: {
        "part": part,
        "state": "editor"
      },
      on: {
        "update": _vm.updateContent
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'module') ? _c('document-part-module', {
      attrs: {
        "part": part,
        "state": "editor"
      },
      on: {
        "update": _vm.updateContent
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'pricing-table') ? _c('document-part-pricing-table', {
      attrs: {
        "part": part,
        "state": "editor"
      },
      on: {
        "update": _vm.updateContent
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'page-break') ? _c('document-part-page-break', {
      attrs: {
        "state": "editor"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'initials') ? _c('document-part-initials', {
      attrs: {
        "signatures": _vm.payload.signatures,
        "part": part,
        "state": "editor"
      }
    }) : _vm._e(), _vm._v(" "), (part.type === 'signatures') ? _c('document-part-signatures', {
      attrs: {
        "signatures": _vm.payload.signatures,
        "part": part,
        "state": "editor"
      }
    }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      staticClass: "options-wrapper"
    }, [_c('router-link', {
      class: {
        'is-hidden': _vm.$route.path.indexOf('/module/') > -1, 'is-hidden': _vm.$route.path.indexOf('/template/') > -1
      },
      attrs: {
        "to": '/a/document/' + _vm.payload.id + '/comments'
      }
    }, [_c('span', [_c('i', {
      staticClass: "icon icon-new-comment"
    })])]), _vm._v(" "), _c('span', {
      on: {
        "click": function($event) {
          _vm.deletePart(key)
        }
      }
    }, [_c('i', {
      staticClass: "icon icon-trash"
    })])], 1)])])
  }))], 1)], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d5f143d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/partials/document-editor-main.vue
// module id = 529
// module chunks = 0